import React, { useContext, useEffect, useState } from 'react';
import { Tab, Table, Tabs } from 'react-bootstrap';
import BestwayTransactionLine from './BestwayTransactionLine';
import { useAlert } from 'react-alert';
import AuthContext from '../../../authentication/AuthContext';
import axios from 'axios';

export default function BestwayTransactionLines({ depotId, transactionId }) {
    const [lines, setLines] = useState([]);
    const alert = useAlert();
    const cas = useContext(AuthContext);

    useEffect(() => {
        axios
            .get(
                window.CONFIG['ws.activoc-web-order-api.bestway.basket']
                    .replace('{depot}', depotId)
                    .replace('{id}', transactionId),
                {
                    headers: {
                        Authorization: cas,
                        'Content-Type': 'application/json'
                    }
                }
            )
            .then(response => {
                setLines(response.data.map(line => <BestwayTransactionLine line={line} />));
            })
            .catch(e => {
                console.error(e);
                alert.error('ERROR: Unable to retrieve transaction basket');
            });
    }, []);

    return (
        <Tabs id={'order-lines-nav'} activeKey={'accepted'}>
            <Tab eventKey={'accepted'} title={'Accepted'}>
                <div>
                    <Table className={'product-range-table'}>
                        <thead>
                            <tr>
                                <th className={'image-column centered column-7'}>Image</th>
                                <th className={'column-7'}>Code</th>
                                <th>Description</th>
                                <th className={'column-9'}>Unit Size</th>
                                <th className={'column-10'}>Invoice Cost</th>
                                <th className={'centered column-7'}>Accepted</th>
                                <th className={'centered column-7'}>Status</th>
                            </tr>
                        </thead>
                        <tbody>{lines}</tbody>
                    </Table>
                </div>
            </Tab>
        </Tabs>
    );
}
